import { render, staticRenderFns } from "./goodsDetails.vue?vue&type=template&id=6b0275bb&scoped=true&"
import script from "./goodsDetails.vue?vue&type=script&lang=js&"
export * from "./goodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetails.vue?vue&type=style&index=0&id=6b0275bb&scoped=true&lang=scss&"
import style1 from "./goodsDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0275bb",
  null
  
)

component.options.__file = "goodsDetails.vue"
export default component.exports